// This is a consistent shuffle through rerenders
export function consistentShuffleArray<T>(arr: T[], shuffleHash: string): T[] {
    const tempArr = [...arr];
    const shuffledArr = [];
    for (let i = arr.length - 1; i >= 0; i--) {
        const indexToTake = shuffleHash.charCodeAt(i % shuffleHash.length) % tempArr.length;
        shuffledArr.push(tempArr[indexToTake]);
        tempArr.splice(indexToTake, 1);
    }
    return shuffledArr;
}
